import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";
import { themeStructure } from "@vcl";
import { compileSpacingSides } from "%/dynamic-component-editor/helpers/spacing-sides";

export const PADDING_DEFAULT_EMPTY_VALUE = "none";

const UNSET_PADDING_VALUES = ["0px", PADDING_DEFAULT_EMPTY_VALUE];
const PADDING_SIDE_SUFFIXES = { top: "Top", right: "Right", bottom: "Bottom", left: "Left" };

export default class Padding extends BaseOption {

  static userInterfaceComponent = {
    label: "Padding",
    component: inspectorTools.SPACING_PICKER,
    useCustomLabel: true,
    useVerticalOrientation: true,
    useDefaultVariableLinking: false,
    canSetOtherStates: [BaseOption.$states.HOVER],
    props: {
      options: themeStructure.size.spacing,
      heading: this.label,
    },
  };

  static defaultValue = {
    top: "standard",
    right: "standard",
    bottom: "standard",
    left: "standard",
  };

  static convertConfigValueToCompiledValue(configValue, themeId = null, themeMode = null) {
    return compileSpacingSides("padding", configValue, Object.keys(this.defaultValue), alias => BaseOption._getStyleValuePropertiesFromTheme("size.spacing", themeId, themeMode, alias));
  }

  static buttonSizeOverrides(compiledPadding, buttonSize) {
    const overrides = {};
    Object.entries(PADDING_SIDE_SUFFIXES).forEach(([side, suffix]) => {
      const value = compiledPadding?.[side];
      if (value && !UNSET_PADDING_VALUES.includes(value)) {
        overrides[`${buttonSize}Padding${suffix}`] = value;
      }
    });
    return overrides;
  }

  static convertValueToStringForTransactionLog(compiledValue) {
    return `Top: ${compiledValue?.top || "none"}, Right: ${compiledValue?.right || "none"}, Bottom: ${compiledValue?.bottom || "none"}, Left: ${compiledValue?.left || "none"}`;
  }
}
